<script>
  import CursoLista from '~modulos/curso/componentes/Lista.vue'
  import tipoUsuario from '~js/tipo-usuario';
  
  export default {
    components: {CursoLista},
    name: 'dashboard',
    data() {
      return {
        animated: true,
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      aluno() {
        return this.usuario.tipoUsuario === tipoUsuario.Aluno;
      },
      fornecedor() {
        return this.usuario.tipoUsuario === tipoUsuario.Fornecedor;
      },
      fornecedorWeb() {
        return this.usuario.tipoUsuario === tipoUsuario.FornecedorWeb;
      },
      fornecedorWebNovo() {
        return this.usuario.tipoUsuario === tipoUsuario.FornecedorWebNovo;
      },
      importacao() {
        return this.usuario.tipoUsuario === tipoUsuario.Importacao;
      },
    },
    mounted() {
      this.$root.tituloDaPagina = (this.usuario.tipoUsuario === tipoUsuario.Aluno ? 'Cursos' : 'Página Inicial');

      this.$root.botaoAcaoMostrar = false;
      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      if ((this.usuario.tipoUsuario === tipoUsuario.Coordenador) || (this.usuario.tipoUsuario === tipoUsuario.Importacao)) {
        if (this.usuario.senhaExpirada){
          this.$router.push({ name: 'alterar-senha' });
        }
      }
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">
    <curso-lista v-if="aluno"></curso-lista>
    <div v-if="fornecedor || fornecedorWeb || fornecedorWebNovo">
      <div class="" v-if="this.configuracao.instrucoesFornecedor" v-html="configuracao.instrucoesFornecedor"></div>
    </div>   
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/dashboard/Dashboard.vue